"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var IQ = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_IQ_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.674 9.533a.528.528 0 0 1-.468.243.54.54 0 0 1-.46-.234c-.113-.162-.194-.393-.242-.693-.048-.3-.072-.66-.072-1.08 0-.426.024-.786.072-1.08.048-.3.126-.525.234-.675a.549.549 0 0 1 .468-.234c.3 0 .5.168.603.504.102.33.153.825.153 1.485 0 .414-.021.771-.063 1.071-.042.3-.117.531-.225.693Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C2.28 2 3.12 2 4.8 2h6.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C16 4.28 16 5.12 16 6.8v2.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C13.72 14 12.88 14 11.2 14H4.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C0 11.72 0 10.88 0 9.2V6.8Zm10.342 4.268.575 1.552h1.512l-.86-2.022a1.87 1.87 0 0 0 .32-.381 2.94 2.94 0 0 0 .405-1.035c.09-.408.135-.876.135-1.404 0-.528-.045-.996-.135-1.404a2.944 2.944 0 0 0-.405-1.044 1.768 1.768 0 0 0-.693-.639c-.282-.144-.618-.216-1.008-.216-.522 0-.948.132-1.278.396-.324.258-.564.633-.72 1.125-.156.486-.234 1.077-.234 1.773 0 .534.045 1.008.135 1.422.09.408.225.753.405 1.035.186.276.417.486.693.63.282.144.615.216.999.216.052 0 .104-.001.154-.004ZM3.57 9.938V11h3.7V9.938l-1.126-.135V5.771l1.125-.135V4.574H3.57v1.062l1.161.135v4.032l-1.16.135Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_IQ_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = IQ;
exports["default"] = _default;